module.exports = __webpack_public_path__ + "media/images/gifts/music/sug_musica_2-8790e8356faea332924a8f2a781e0150.jpg";